module.exports = __webpack_public_path__ + "static/media/blogban.5888be66.svg";